import { useSyncExternalStore, type ReactNode } from 'react';
import type { GameClient } from './net/client.js';
import { Notice, StatusBar, WarningSheet } from './components/common.js';
import { Lobby } from './views/Lobby.js';
import { Setup } from './views/Setup.js';
import { Game } from './views/Game.js';

export function App({ client }: { client: GameClient }): ReactNode {
  const state = useSyncExternalStore(client.subscribe, client.getSnapshot, client.getSnapshot);

  const body =
    state.game.status === 'lobby' || !state.seatId ? <Lobby state={state} client={client} />
    : state.game.status === 'setup' ? <Setup state={state} client={client} />
    : <Game state={state} client={client} />;

  return (
    <div className="app">
      <StatusBar state={state} />
      <Notice state={state} client={client} />
      {body}
      <WarningSheet state={state} client={client} />
    </div>
  );
}
